import React  from "react";
import { useTranslation,Trans  } from 'react-i18next';
const Grsf = () => {
    const { t } = useTranslation();
    return (
        <section className="lyt-section typ-pb-0" id="wcgrsf">
            <div className="container">
                <div className="heading-wrapper typ-mb-60 justify-content-center">
                    <div className="text-center">
                        <h2
                            className="bs-heading typdblue mb-3"
                            data-aos="fade-in"
                            data-aos-delay="200"
                        >
                            {t('whyChooseGRSF')}
                        </h2>
                        <p
                            className="bs-para typgrey"
                            data-aos="fade-in"
                            data-aos-delay="300"
                        >
                           {t('grsfSubTitle')}
                        </p>
                    </div>
                </div>
            </div>
            {/* <div className="container typ-custom-container"> */}
            <div className="typ-container-bg">
                <div className="container">
                    <div className="row typ-align-center">
                        <div className="col-lg-6 col-md-6">
                            <div className='img-box' data-aos="fade-in" data-aos-delay="200">
                                <img
                                    className="img-fluid"
                                    src="/images/about/founded-place.png"
                                    alt="founded"
                                    width={541}
                                    height={584}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <p className="bs-para typ-24 typwhite ">{t('grsfDesc')}</p>

                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default Grsf;
